export default "__VITE_ASSET__Cgm2RmFW__"